import { useService } from "@providersV2";
import { CourseItemService } from "@servicesV2";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

export type CourseOutlineProviderParams = {
  courseId: string | undefined;
};

export function useCourseOutlineProvider({
  courseId,
}: CourseOutlineProviderParams) {
  const { initialization: courseServiceInit } = useService(CourseItemService);

  return useQuery({
    enabled: courseId !== undefined,
    queryKey: ["course", courseId, "outline"],

    async queryFn() {
      const { service: courseItemService } = await courseServiceInit;

      return courseItemService.getOutline(z.string().parse(courseId));
    },
  });
}
